import CircularProgress from '@mui/material/CircularProgress';

const Loading = () => (
  <div style={{ color: '#D9D9D9', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    <CircularProgress color="inherit" />
  </div>
)

export default Loading